import React from 'react';
import cx from 'classnames';
import Avatar from '../../../../components/Avatar';
import Button from '../../../../components/Button';
import { observer } from 'mobx-react';
import ResponseValue from '../ResponseValue';
var PromptItem = function PromptItem(_ref) {
  var _prompt$createdBy, _prompt$createdBy2;
  var prompt = _ref.prompt,
    store = _ref.store,
    view = _ref.view;
  return /*#__PURE__*/React.createElement("div", {
    className: "prompt-item",
    "data-test": 'prompt-item-' + prompt.title
  }, /*#__PURE__*/React.createElement("div", {
    className: "avatar-container"
  }, /*#__PURE__*/React.createElement(Avatar, {
    size: 35,
    checked: !prompt.isPendingResponse,
    url: (_prompt$createdBy = prompt.createdBy) === null || _prompt$createdBy === void 0 ? void 0 : _prompt$createdBy.avatar,
    fallback: (_prompt$createdBy2 = prompt.createdBy) === null || _prompt$createdBy2 === void 0 ? void 0 : _prompt$createdBy2.avatarFallback
  })), prompt.isPendingResponse ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx('prompt-line')
  }, /*#__PURE__*/React.createElement("div", {
    className: "prompt-line__title"
  }, prompt.title), /*#__PURE__*/React.createElement("div", {
    className: "prompt-line__pending"
  }, prompt.isDesignee ? 'Pending your response' : 'Pending response')), /*#__PURE__*/React.createElement(Button, {
    type: prompt.canAnswer ? 'primary' : 'default',
    onClick: function onClick() {
      return view(prompt);
    },
    dataTest: "prompt-view-button"
  }, prompt.canAnswer ? 'Respond' : 'View')) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "prompt-line"
  }, /*#__PURE__*/React.createElement("div", {
    className: "prompt-line__title"
  }, prompt.title), /*#__PURE__*/React.createElement(ResponseValue, {
    vm: prompt.question
  })), /*#__PURE__*/React.createElement(Button, {
    onClick: function onClick() {
      return view(prompt);
    },
    dataTest: "prompt-view-button"
  }, "View")));
};
export default observer(PromptItem);
//# sourceMappingURL=index.js.map
